import React from "react";
import { FormatNumber2 } from "../../utility/functions/formatNumber";
import { useSelector } from "react-redux";
import { selectWidth } from "../../utility/Redux/profile";

const Footer = ({ columns, rows,totalFields, isFeilds }) => {
  const validBill = rows.filter((row) => row.BILL_STATUS !== "Void");
  const width = useSelector(selectWidth);

  // Calculate sums once instead of multiple times
  const totals = validBill.reduce(
    (acc, row) => {
      return {
        GTOTAL: acc.GTOTAL + Number(row.GTOTAL),
        TOTAL: acc.TOTAL + Number(row.TOTAL),
        AMOUNT: acc.AMOUNT + Number(row.AMOUNT),
        TAX1_AMT: acc.TAX1_AMT + Number(row.TAX1_AMT),
        TAX2_AMT: acc.TAX2_AMT + Number(row.TAX2_AMT),
        DISQ_AMT: acc.DISQ_AMT + Number(row.DISQ_AMT),
      };
    },
    {
      GTOTAL: 0,
      TOTAL: 0,
      AMOUNT: 0,
      TAX1_AMT: 0,
      TAX2_AMT: 0,
      DISQ_AMT: 0,
    }
  );

  const getFontSize = () => {
    if (width < 500) return "11px";
    if (width < 1281) return "12px";
    return "14px";
  };

  const getBorderStyle = (index,isSecRow) => ({
    fontSize: getFontSize(),
    width: columns[index].width,
    borderLeft: "1px solid black",
    borderRight:
      index === columns.length - 1 ? "1px solid black" : "0px solid black",
    borderBottom: "1px solid black",
    borderTop: isSecRow ?"0px solid black":"1px solid black",
  });

  const renderCellContent = (field) => {
    if (field === "NAME") return "Total";

    const total = totals[field];
    if (total > 0) {
      return FormatNumber2(total);
    }
    return null;
  };

  if (!isFeilds) {
    return (
      <div className="flex flex-col w-full mt-1">
        
        {/* ROW 1 → TOTAL */}
        <div className="flex">
          {columns.map((column, index) => (
            <div
              key={index}
              style={getBorderStyle(index)}
              className="p-1 text-right"
            >
              {column.field === "NAME"
                ? "Total"
                : totals[column.field] > 0
                ? FormatNumber2(totals[column.field])
                : null}
            </div>
          ))}
        </div>
  
        {/* ROW 2 → GRAND TOTAL */}
        <div className="flex">
          {columns.map((column, index) => (
            <div
              key={index}
              style={{
                ...getBorderStyle(index,true),
                background: "#f5f5f5",
                fontWeight: "bold",
              }}
              className="p-1 text-right"
            >
              {column.field === "NAME"
                ? "Grand Total"
                : column.field === "GTOTAL"
                ? FormatNumber2(totalFields.GTOTAL)
                : null}
                {column.field === "CASH_AMOUNT" &&FormatNumber2(totalFields.CASH_AMOUNT) }
                {column.field === "CARD_AMOUNT" &&FormatNumber2(totalFields.CARD_AMOUNT) }
                {column.field === "E_AMOUNT" &&FormatNumber2(totalFields.E_AMOUNT) }
                {column.field === "TOTAL" &&FormatNumber2(totalFields.TOTAL) }
                {column.field === "BTC_AMOUNT" &&FormatNumber2(totalFields.BTC_AMOUNT) }
            </div>
          ))}
        </div>
  
      </div>
    );
  } else {
    return <div>{isFeilds}</div>;
  }
};

export default Footer;
